const STORAGE_KEY = "academy-theme";

/**
 * Wraps Vuetify's own theme system (not a custom CSS-variable scheme) so
 * teleported overlays (bottom sheets, dialogs) stay correctly themed —
 * Vuetify's theme context propagates via provide/inject, which survives
 * teleportation, unlike a plain `.v-theme--dark` class scoped to one DOM
 * subtree would.
 *
 * Dark mode is temporarily disabled — only light mode is offered for now,
 * so this always forces light regardless of any previously saved choice.
 */
export function useAppTheme() {
  const theme = useTheme();

  const isDark = computed(() => theme.global.current.value.dark);

  function setTheme(name: "light" | "dark") {
    theme.global.name.value = name;
    if (import.meta.client) localStorage.setItem(STORAGE_KEY, name);
  }

  function toggleTheme() {
    setTheme(isDark.value ? "light" : "dark");
  }

  function initTheme() {
    if (!import.meta.client) return;
    theme.global.name.value = "light";
    localStorage.removeItem(STORAGE_KEY);
  }

  return { isDark, setTheme, toggleTheme, initTheme };
}
